import * as React from "react";
import { translate } from "react-i18next";
import { IActivityMobile } from "./ActivityMobile";
import { ActivityMobileDefaultView } from "./ActivityMobile.Default.view";

const ActivityMobileComponentView = (props: IActivityMobile) => (
  <ActivityMobileDefaultView {...props} />
);

export const ActivityMobileView: any = translate("keypad")(
  ActivityMobileComponentView
);
